import { Injectable, EventEmitter, Output } from '@angular/core';
import { UserService } from './user.service';
import { MrService } from '../../components/auth/mr.service';
import { HttpClient } from '@angular/common/http';
import { safeCb } from '../util';
import { userRoles } from '../../app/app.constants';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
// @flow
class User {
    _id = '';
    name = '';
    email = '';
    role = '';
    isDummyPwd = '';
}

@Injectable({
    providedIn: 'root',
  })
export class AuthService {
    _currentUser: User = new User();
    @Output() currentUserChanged = new EventEmitter(true);
    userRoles = userRoles || [];
    UserService;
    MrService;
    IsMRLogin: number = 0;
    private systemConfigDetailsSubject = new BehaviorSubject<any[]>([]);
    public systemConfigDetails$ = this.systemConfigDetailsSubject.asObservable();
    static parameters = [HttpClient, UserService, MrService];
    constructor(private http: HttpClient, private userService: UserService,  private mrService: MrService) {
        this.http = http;
        this.UserService = userService;
        this.MrService = mrService;
        this.loadInitialConfig();
    }

    isLoggedIn(callback?) {
        let is = !!this.currentUser._id;
        if (is || !localStorage.getItem('id_token')) {
            //Got the user locally, or there is no id_token stored
            safeCb(callback)(is);
            return Promise.resolve(is);
        } else {
            //User not yet loaded locally, but id_token is present
            let isMrLogin = this.IsMRLogin;
            if ('user' in localStorage) {
                const User = JSON.parse(localStorage.getItem('user') as string);
                isMrLogin = User.isMrLogin ? 1 : 0;
              }
              if (isMrLogin) {
                return this.mrService
                  .get()
                  .toPromise()
                  .then((user: any) => {
                    this.currentUser = user;
                    return !!this.currentUser._id;
                  })
                  .catch(err => {
                    localStorage.clear();
                    return false;
                  });
              } else {
            return this.UserService.get().toPromise()
                .then((user: User) => {
                    this.currentUser = user;
                    return !!this.currentUser._id;
                })
                .catch(err => {
                    localStorage.clear();
                    return false;
                });
        }
    }
}
    /**
     * Check if userRole is >= role
     * @param {String} userRole - role of current user
     * @param {String} role - role to check against
     */
    static hasRole(userRole, role) {
        return userRoles.indexOf(userRole) >= userRoles.indexOf(role);
    }

    get currentUser() {
        return this._currentUser;
    }

    set currentUser(user) {
        this._currentUser = user;
        this.currentUserChanged.emit(user);
    }

    /**
     * Authenticate user and save token
     *
     * @param  {Object}   user     - login info
     * @param  {Function} [callback] - function(error, user)
     * @return {Promise}
     */
    
    login({ email, password }: any, callback?: any) {
        // let payload = this.encryptPayload({ email, password });
        const secretKey = '69840688735777849970480444051381';  // Must match backend
        const iv = '4843985102616320'; // IV should be 16 bytes and match the backend

        // Encrypt using AES with key and IV
        const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(secretKey), {
          iv: CryptoJS.enc.Utf8.parse(iv),
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });

        const encryptedPassword = encrypted.toString(); // Default is Base64

        const headers= {
          'Content-Type': 'application/json',
          'X-ERP-Client': 'true',  // Custom header to identify ERP requests
        };
        return this.http
          .post('/auth/local', {
            email,
            // password,
            password:encryptedPassword
          }, {headers: headers})
          .toPromise()
          .then(async (res: any) => {
            let user: any;
            localStorage.setItem('id_token', res.token);
            let promiseUser = await Promise.all([
              new Promise((resolve, reject) => {
                this.UserService.get().subscribe(item => {
                  resolve(item);
                });
              }),
            ]);
            user = promiseUser[0];
            this.currentUser = user;
            let PromiseUserPermis = await Promise.all([
              new Promise((resolve, reject) => {
                this.http
                  .get('/api/users/getpermission/' + this.currentUser._id)
                  .subscribe((result: any) => {
                    if ('permission' in localStorage) {
                      localStorage.removeItem('permission');
                    }
                    localStorage.setItem('permission', JSON.stringify(result));
                    resolve(true);
                  });
              }),
            ]);
            localStorage.setItem('user', JSON.stringify(user));
            safeCb(callback)(null, user);
            return user;
          })
          .catch(err => {
            this.logout();
            safeCb(callback)(err);
            return Promise.reject(err);
          });
      }
    
      async MRlogin({ email, password }: any, callback?: any) {
        try {
          // let payload = this.encryptPayload({ email, password, mode: 'MR' });
          const secretKey = '69840688735777849970480444051381';  // Must match backend
          const iv = '4843985102616320'; // IV should be 16 bytes and match the backend

          // Encrypt using AES with key and IV
          const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(secretKey), {
            iv: CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
          });

          const encryptedPassword = encrypted.toString(); // Default is Base64

          const headers= {
            'Content-Type': 'application/json',
            'X-ERP-Client': 'true',  // Custom header to identify ERP requests
          };
          const res: any = await this.http
            .post('/auth/local', {
              email,
              // password,
              mode: 'MR',
              password:encryptedPassword
          }, {headers: headers})
            // .post('/auth/local', {"payload":payload})
            .toPromise();
          let user: any;
          localStorage.setItem('id_token', res.token);
          let promiseUser = await Promise.all([
            new Promise((resolve, reject) => {
              this.MrService.get().subscribe((item: any) => {
                item.isMrLogin = 1;
                resolve(item);
              });
            }),
          ]);
          user = promiseUser[0];
          this.currentUser = user;
          let PromiseUserPermis = await Promise.all([
            new Promise((resolve, reject) => {
              this.http
                .get('/api/users/getpermission/' + this.currentUser._id)
                .subscribe((result: any) => {
                  if ('permission' in localStorage) {
                    localStorage.removeItem('permission');
                  }
                  localStorage.setItem('permission', JSON.stringify(result));
                  resolve(true);
                });
            }),
          ]);
          const mfgDetail: any = await this.http
            .get('/api/manufacturers/GetManufactureDivisionMRWise/' + user._id)
            .toPromise();
          if (mfgDetail.length > 0) {
            user = { ...user, ...mfgDetail[0] };
          }
          localStorage.setItem('user', JSON.stringify(user));
          safeCb(callback)(null, user);
          return await user;
        } catch (err) {
          this.logout();
          safeCb(callback)(err);
          return await Promise.reject(err);
        }
      }

      GetSystemConfigDetails(data) {
        // this.http.post('/api/users/GET_SYSTEM_CONFIG_DETAILS', data)
        //     .subscribe(result => {
        //         if ("SystemConfigDetails" in localStorage) {
        //             localStorage.removeItem('SystemConfigDetails');
        //         }
        //         localStorage.setItem('SystemConfigDetails', JSON.stringify(result));
        //     });
        this.fetchAndUpdateSystemConfig(data).subscribe();
      }
      fetchAndUpdateSystemConfig(data: any): Observable<any[]> {
        return this.http.post<any[]>('/api/users/GET_SYSTEM_CONFIG_DETAILS', data).pipe(
          tap(result => {
            // Cache the result in local storage
            localStorage.setItem('SystemConfigDetails', JSON.stringify(result));
            // Update the BehaviorSubject to notify all subscribers
            this.systemConfigDetailsSubject.next(result);
          }),
          catchError(error => {
            console.error('Error fetching system config details', error);
            // Fallback to empty array if there's an error
            return of([]);
          })
        );
      }
    /**
     * Delete access token and user info
     * @return {Promise}
     */
    logout() {
        localStorage.removeItem('user');
        localStorage.removeItem('id_token');
        localStorage.removeItem('permission');
        localStorage.clear();
        this.currentUser = new User();
        return Promise.resolve();
    }

    /**
     * Create a new user
     *
     * @param  {Object}   user     - user info
     * @param  {Function} callback - optional, function(error, user)
     * @return {Promise}
     */
    createUser(user, callback) {
        return this.UserService.create(user).toPromise()
            .then(data => {
                localStorage.setItem('id_token', data.token);
                return this.UserService.get().toPromise();
            })
            .then((_user: User) => {
                this.currentUser = _user;
                return safeCb(callback)(null, _user);
            })
            .catch(err => {
                this.logout();
                safeCb(callback)(err);
                return Promise.reject(err);
            });
    }

    /**
     * Change password
     *
     * @param  {String}   oldPassword
     * @param  {String}   newPassword
     * @param  {Function} [callback] - function(error, user)
     * @return {Promise}
     */
    changePassword(oldPassword, newPassword, callback) {
        return this.UserService.changePassword({ id: this.currentUser._id }, oldPassword, newPassword)
            .toPromise()
            .then(res => safeCb(callback)(res))
            .catch(err => safeCb(callback)(err));
    }

    /**
     * Gets all available info on a user
     *
     * @param  {Function} [callback] - function(user)
     * @return {Promise}
     */
    getCurrentUser(callback?) {
        safeCb(callback)(this.currentUser);
        return Promise.resolve(this.currentUser);
    }

    /**
     * Gets all available info on a user
     *
     * @return {Object}
     */
    getCurrentUserSync() {
        return this.currentUser;
    }

    /**
     * Checks if user is logged in
     * @param {function} [callback]
     * @returns {Promise}
     */
    // isLoggedIn(callback?) {
    //     let is = !!this.currentUser._id;
    //     safeCb(callback)(is);
    //     return Promise.resolve(is);
    // }

    /**
     * Checks if user is logged in
     * @returns {Boolean}
     */
    isLoggedInSync() {
        return !!this.currentUser._id;
    }

    /**
     * Check if a user is an admin
     *
     * @param  {Function|*} [callback] - optional, function(is)
     * @return {Promise}
     */
    isAdmin(callback?) {
        return this.getCurrentUser().then(user => {
            var is = user.role === 'admin';
            safeCb(callback)(is);
            return is;
        });
    }

    isAdminSync() {
        return this.currentUser.role === 'admin';
    }

    /**
     * Get auth token
     *
     * @return {String} - a token string used for authenticating
     */
    getToken() {
        return localStorage.getItem('id_token');
    }

    private loadInitialConfig() {
      const localStorageItem = localStorage.getItem('SystemConfigDetails');
      if (localStorageItem) {
        this.systemConfigDetailsSubject.next(JSON.parse(localStorageItem));
      }
    }
    private secretKey = CryptoJS.enc.Utf8.parse('69840688735777849970480444051381'); // 32 characters for AES-256
    private iv = CryptoJS.enc.Utf8.parse('4843985102616320'); // 16 characters for IV
    encryptPayload(payload: any): string {
      const jsonPayload = JSON.stringify(payload);
      const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(jsonPayload), this.secretKey, {
        keySize: 256 / 8,
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    }

    resetPassword(email, newPassword, callback) {
      return this.UserService.resetPassword(email, newPassword)
        .toPromise()
        .then(res => safeCb(callback)(res))
        .catch(err => safeCb(callback)(err));
    }   
}